// import React, { useState } from "react";
// import { Card, Button } from "@mui/material"; // adjust as per your UI lib
// import Map from "./MapView";

// const MapSiteInspection = ({ formData }) => {
//   const [showMap, setShowMap] = useState(false);
//   const latLong = formData?.descriptionOfLand?.latitude && formData?.descriptionOfLand?.longitude
//   ? `${formData.descriptionOfLand.latitude},${formData.descriptionOfLand.longitude}`
//   : null;

//   return (
//     <React.Fragment>
//       {latLong && (
//         <React.Fragment>
//           {!showMap ? (
//             <Button
//               variant="contained"
//               onClick={() => setShowMap(true)}
//               style={{ marginBottom: "10px" }}
//             >
//               Show Map
//             </Button>
//           ) : (
//             <Card
//               style={{
//                 paddingBottom: "15px",
//                 marginTop: "5px",
//                 marginBottom: "5px",
//               }}
//             >
//               <div
//                 style={{
//                   textAlign: "center",
//                   backgroundColor: "#99b3d98c",
//                   padding: "5px",
//                   color: "black",
//                   border: "2px solid rgba(91, 90, 95, 0.35)",
//                 }}
//               >
//                 <b>Map</b>
//               </div>
//               <div
//                 className="row"
//                 style={{ marginLeft: "0px", marginTop: "1%" }}
//               >
//                 <Map formData={latLong} />
//               </div>
//             </Card>
//           )}
//         </React.Fragment>
//       )}
//     </React.Fragment>
//   );
// };

// export default MapSiteInspection;


import React, { useState } from "react";
import { Button, Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import Map from "./MapView";



const MapSiteInspection = ({ formData }) => {
  const [openMap, setOpenMap] = useState(false);
  // Assuming you have lat & long from formData
  const latLong = formData?.descriptionOfLand?.latitude && formData?.descriptionOfLand?.longitude
    ? `${formData.descriptionOfLand.latitude},${formData.descriptionOfLand.longitude}`
    : null;
  return (
    <React.Fragment>
      {latLong && (
        <React.Fragment>
          <Button
            variant="contained"
            onClick={() => setOpenMap(true)}
            style={{ marginBottom: "10px" }}
          >
            Show Map
          </Button>

          <Dialog
            open={openMap}
            onClose={() => setOpenMap(false)}
            maxWidth={false}
            PaperProps={{
              style: {
                marginTop: "5%",
                width: '65%',
                maxWidth: '65%',
                maxHeight: 460,
                overflow: 'auto',
              },
            }}
          >
            <DialogTitle sx={{ m: 0, p: 2 }}>
              Map
              <IconButton
                aria-label="close"
                onClick={() => setOpenMap(false)}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>

            <DialogContent dividers>
              <div className="row" style={{ marginLeft: "0px", marginTop: "1%" }}>
                <Map formData={latLong} />
              </div>
            </DialogContent>
          </Dialog>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};


export default MapSiteInspection;
